import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Button, Modal, useMessage } from '@pepper/ui'

import deleteItems from 'utils/api/deleteItems'
import { pluralize } from '@pepper/utils/src/function/pluralize'

type Props = {
  items: Item[] | Assignment[]
  onSuccess?: () => void
  onClose?: () => void
}

const DeleteItemModal = NiceModal.create<Props>(
  ({ items, onSuccess, onClose }) => {
    const { showError, showSuccess } = useMessage()
    const { visible, remove } = useModal()

    const handleDelete = async () => {
      try {
        await deleteItems({ ids: items.map(item => item.id) })
        showSuccess('Selected Item(s) deleted successfully')
        onSuccess?.()
      } catch (error) {
        showError(error.message)
      }
      onClose?.()
      remove()
    }

    return (
      <Modal
        size="sm"
        title={pluralize(items.length, 'Item')}
        footer={
          <div>
            <Button type="primary" onClick={handleDelete}>
              Delete
            </Button>
            <Button type="link" onClick={remove}>
              Cancel
            </Button>
          </div>
        }
        visible={visible}
        closable={false}
        onCancel={remove}
      >
        {items.length > 1 ? `${items.length} items` : `${items[0].title}`} will
        be deleted permanently. If shared, collaborators will not be able to
        access it through the link shared with them.
      </Modal>
    )
  }
)

export default DeleteItemModal
